import { Link, useLocation } from "react-router-dom";
import { CaretRight, House } from "@phosphor-icons/react";

const LABELS = {
    "": "Home",
    purchase: "Purchase invoices",
    sales: "Sales invoices",
    advances: "Customer advances",
    bank: "Bank statements",
    ledgers: "Ledgers",
    reports: "Reports",
    payables: "Payables",
    receivables: "Receivables",
    expenses: "Expenses",
    "chart-of-accounts": "Chart of accounts",
    users: "Users & roles",
    "audit-log": "Audit log",
};

export default function Breadcrumbs() {
    const { pathname } = useLocation();
    if (pathname === "/" || pathname === "/login") return null;
    const parts = pathname.split("/").filter(Boolean);
    // Build accumulating paths
    const crumbs = [{ href: "/", label: "Home", icon: true }];
    let acc = "";
    parts.forEach((p, i) => {
        acc += `/${p}`;
        const isLast = i === parts.length - 1;
        // If the segment is a UUID-ish id, label it as "Detail"
        const label = LABELS[p] || (/^[0-9a-f]{8}-/i.test(p) ? "Detail" : p);
        crumbs.push({ href: acc, label, active: isLast });
    });
    return (
        <div className="px-8 pt-4 flex items-center gap-1.5 text-xs" data-testid="breadcrumbs">
            {crumbs.map((c, i) => {
                const isLast = i === crumbs.length - 1;
                return (
                    <span key={c.href} className="flex items-center gap-1.5">
                        {c.icon ? (
                            <Link to={c.href} className="flex items-center gap-1 text-stone-500 hover:text-stone-900">
                                <House size={12} weight="duotone" style={{ color: "var(--se-brand)" }} />
                            </Link>
                        ) : isLast ? (
                            <span className="font-medium" style={{ color: "var(--se-ink)" }}>{c.label}</span>
                        ) : (
                            <Link to={c.href} className="text-stone-500 hover:text-stone-900 capitalize">
                                {c.label}
                            </Link>
                        )}
                        {!isLast && <CaretRight size={10} weight="bold" className="text-stone-400" />}
                    </span>
                );
            })}
        </div>
    );
}
